import type { useSentry } from '@/composables/utils/useSentry';
import type { useMicroCMSGetList } from '@/wabunka-src/common/composables/query/useMicroCMSClient';

export type UseRuntimeConfig = typeof useRuntimeConfig;
export const useRuntimeConfigKey = Symbol() as InjectionKey<UseRuntimeConfig>;

export type UseFetchFromPublicWabunkaApi = typeof useFetchFromPublicWabunkaApi;
export const useFetchFromPublicWabunkaApiKey = Symbol() as InjectionKey<UseFetchFromPublicWabunkaApi>;

export type UseFetch = typeof useFetch;
export const useFetchKey = Symbol() as InjectionKey<UseFetch>;

export type UseRouter = typeof useRouter;
export const useRouterKey = Symbol() as InjectionKey<UseRouter>;

export type UseRoute = typeof useRoute;
export const useRouteKey = Symbol() as InjectionKey<UseRoute>;

export type StateFactory = typeof stateFactory;
export const stateFactoryKey = Symbol() as InjectionKey<StateFactory>;

export type UseState = typeof useState;
export const useStateKey = Symbol() as InjectionKey<UseState>;

export type UseSentry = typeof useSentry;
export const useSentryKey = Symbol() as InjectionKey<UseSentry>;

export type UseMicroCMSGetList = typeof useMicroCMSGetList;
export const useMicroCMSGetListKey = Symbol() as InjectionKey<UseMicroCMSGetList>;

// NOTE: 新しく injectionKey を追加する際は、app.vue と error.vue、および test/render.ts に provide を追加すること。
// inject 側は型アサーションで受けるため、provide が漏れていても型では気付けず実行時まで露見しない。
